const getAlarms = state => state.alarms;
const getAlarm = state => state.alarm;
const getMeta = state => state.meta;

export default {
    getAlarms,
    getAlarm,
    getMeta,
}
